import { useEffect } from 'react'

export default () => {
    useEffect(() => {
        window.parent.postMessage('docusignClose', '*')
    }, [])

    return <>close</>
}
